<template>
  <div id="app">
    <div class="outer-container">
      <!-- 1. 顶部导航区域 -->
      <div class="combined-section">
        <div class="top-row">
          <div class="cell cellbt-30">
            <img
              src="../static/images/GLOBALAIlogo/GLOBALAI3.png"
              alt="Global AI Link Limited"
              class="logo-image"
            />
            <span class="logo-text">Global AI Link Limited</span>
          </div>

          <!-- 导航菜单 -->
          <div class="cell cell-40">
            <!-- Overlay for mobile menu -->
            <div
              class="mobile-menu-overlay"
              v-if="isMenuOpen"
              @click="closeMenu"
            ></div>

            <ul class="nav-list" :class="{ 'mobile-open': isMenuOpen }">
              <li class="nav-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/aboutus">About Us</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/ourbusiness">Our Business</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/contactusdetail">Contact Us</router-link>
              </li>
              <li
                class="nav-item nav-item--dropdown"
                @mouseenter="legalDropdownOpen = true"
                @mouseleave="legalDropdownOpen = false"
              >
                <button
                  type="button"
                  class="nav-dropdown-trigger"
                  :class="{ active: isLegalRouteActive }"
                  @click="toggleLegalDropdown"
                >
                  Legal
                  <span class="nav-dropdown-caret">▾</span>
                </button>
                <ul
                  class="nav-dropdown-menu"
                  :class="{ open: legalDropdownOpen }"
                >
                  <li v-for="item in legalLinks" :key="item.path">
                    <router-link :to="item.path" @click.native="closeMenu">
                      {{ item.label }}
                    </router-link>
                  </li>
                </ul>
              </li>
              <!-- <li class="nav-item">
                <router-link to="/search-arbitrage"
                  >Search Arbitrage</router-link
                >
              </li>
              <li class="nav-item">
                <router-link to="/leadgen">LeadGen</router-link>
              </li> -->
              <!-- <li class="nav-item">
                <button @click="handleCustomButtonClick">Contact Us</button>
              </li> -->
              <!-- <li class="nav-item">
                <button class="btn btn-header-signup" @click="showLoginModal">
                  {{ $t('header_signup_btn') }}
                </button>
              </li> -->
            </ul>
            <!-- Hamburger Button (Mobile Only) -->
            <div
              class="hamburger-btn"
              @click="toggleMenu"
              :class="{ active: isMenuOpen }"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. 主内容区域（路由视图） -->
      <router-view
        @open-form="handleCustomButtonClick"
        @open-login-modal="showLoginModal"
      />

      <SiteFooter @open-form="handleCustomButtonClick" />

      <!-- 3. 联系表单弹窗 -->
      <div v-if="isFormVisible" class="form-popup">
        <div class="form-container">
          <span class="close-btn" @click="closeForm">×</span>
          <div class="form-content">
            <div class="form-fields">
              <h2 class="form-title">Support</h2>
              <form @submit.prevent="submitForm">
                <input
                  type="text"
                  v-model="formData.name"
                  placeholder="Your Name"
                  required
                />
                <input
                  type="email"
                  v-model="formData.email"
                  placeholder="Your Email"
                  required
                />
                <input
                  type="text"
                  v-model="formData.subject"
                  placeholder="Subject"
                  required
                />
                <textarea
                  v-model="formData.message"
                  rows="5"
                  placeholder="Your Message..."
                  required
                ></textarea>
                <button type="submit">SEND</button>
              </form>
            </div>
            <!-- <div class="contact-info">
              <ul>
                <li>
                  <img
                    src="../static/images/advertiser/address.png"
                    alt="Address Icon"
                    class="contact-icon"
                  />
                  <span>{{ $t("contact_info_address") }}</span>
                </li>
                <li>
                  <img
                    src="../static/images/advertiser/email.png"
                    alt="Email Icon"
                    class="contact-icon"
                  />
                  <span>{{ $t("contact_info_email") }}</span>
                </li>
                <li>
                  <img
                    src="../static/images/advertiser/TG.png"
                    alt="WhatsApp Icon"
                    class="contact-icon"
                  />
                  <span>{{ $t("contact_info_whatsapp") }}</span>
                </li>
                <li>
                  <img
                    src="../static/images/advertiser/Whatsapp.png"
                    alt="Telegram Icon"
                    class="contact-icon"
                  />
                  <span>{{ $t("contact_info_telegram") }}</span>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>

      <!-- 4. 登录表单弹窗 -->
      <!-- <div
        v-if="isLoginModalVisible"
        class="login-modal-overlay"
        @click.self="closeLoginModal"
      >
        <div class="login-modal-container">
          <span class="close-btn" @click="closeLoginModal">×</span>
          <h2>Login</h2>
          <p>Please enter your credentials to log in.</p>
          <form @submit.prevent="handleLogin">
            <div class="input-group">
              <label for="username">Account / Email</label>
              <input
                type="text"
                id="username"
                v-model="loginData.username"
                required
              />
            </div>
            <div class="input-group">
              <label for="password">Password</label>
              <input
                type="password"
                id="password"
                v-model="loginData.password"
                required
              />
            </div>
            <button type="submit" class="btn-login">Login</button>
          </form>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SiteFooter from "./components/SiteFooter.vue";

export default {
  name: "App",
  components: {
    SiteFooter,
  },
  data() {
    return {
      // 联系表单相关
      isFormVisible: false,
      formData: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },

      // 登录表单相关
      isLoginModalVisible: false,
      loginData: {
        username: "",
        password: "",
      },
      // Mobile menu state
      isMenuOpen: false,
      legalDropdownOpen: false,
      legalLinks: [
        {
          label: "Terms and Policies",
          path: "/legal/terms-and-policies",
        },
        {
          label: "Privacy Policy",
          path: "/legal/privacy-policy",
        },
        {
          label: "Legal Information",
          path: "/legal/legal-information",
        },
      ],
    };
  },
  computed: {
    isLegalRouteActive() {
      return this.$route.path.startsWith("/legal");
    },
  },
  watch: {
    // Close menu when route changes
    $route() {
      this.closeMenu();
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      // Prevent body scrolling when menu is open
      if (this.isMenuOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.legalDropdownOpen = false;
      document.body.style.overflow = "";
    },
    toggleLegalDropdown() {
      if (window.innerWidth <= 768) {
        this.legalDropdownOpen = !this.legalDropdownOpen;
      }
    },
    handleCustomButtonClick() {
      this.isFormVisible = true;
    },
    closeForm() {
      this.isFormVisible = false;
    },
    submitForm() {
      axios
        .post("/prod-api/email", this.formData)
        .then((response) => {
          console.log("Request successful:", response.data);
          alert("Message sent successfully!");
          this.closeForm();
          this.formData = { name: "", email: "", subject: "", message: "" };
        })
        .catch((error) => {
          console.error("Request failed:", error);
          alert("Failed to send message. Please try again later.");
        });
    },
    showLoginModal() {
      this.isLoginModalVisible = true;
    },
    closeLoginModal() {
      this.isLoginModalVisible = false;
    },
    handleLogin() {
      console.log("Logging in with:", this.loginData);
      alert(`Login attempt for ${this.loginData.username}`);
      this.closeLoginModal();
      this.loginData = { username: "", password: "" };
    },
  },
};
</script>

<style>
/* 全局样式 */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
}
#app {
  width: 100%;
}
</style>

<style lang="scss" scoped>
/* App.vue 组件样式 */
.outer-container {
  width: 100%;
  margin: 0 auto;
}

/* 头部/导航区域 */
.combined-section {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 80px;
  background: transparent;
  box-shadow: none;
  border-bottom: none;
  transition: all 0.3s ease;
  position: relative;
  box-sizing: border-box;
}

.combined-section::before {
  content: "";
  position: absolute;
  inset: 0;
  height: 80px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 4px 24px rgba(28, 43, 78, 0.04);
  border-bottom: 1px solid rgba(75, 137, 255, 0.08);
  z-index: -1;
}

.top-row::before {
  content: none;
}

.cell {
  height: 80px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.cell-40 {
  flex: none;
  box-sizing: border-box;
}

.cell-30 {
  display: none;
}

.cellbt-30 {
  flex: none;
  display: flex;
  align-items: center;
  gap: 14px;
  padding-left: 0;
  box-sizing: border-box;
}

.logo-image {
  height: 38px;
  width: auto;
  object-fit: contain;
}

.logo-text {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.25;
  color: #1c2b4e;
  letter-spacing: -0.3px;
}

.nav-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  gap: 16px;
}

.nav-item {
  white-space: nowrap;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-item a,
.nav-item button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 8px 12px;
  font-family: inherit;
  white-space: nowrap;
  position: relative;
  text-decoration: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.nav-item a::after,
.nav-item button::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 40%;
  height: 3px;
  background: #4b89ff;
  border-radius: 3px 3px 0 0;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-item a:hover,
.nav-item button:hover {
  color: #1c2b4e;
  background-color: rgba(75, 137, 255, 0.05);
}

.nav-item a:hover::after,
.nav-item button:hover::after {
  transform: translateX(-50%) scaleX(1);
}

.nav-item a.router-link-exact-active {
  color: #4b89ff;
  font-weight: 700;
  background-color: transparent;
}

.nav-item a.router-link-exact-active::after {
  transform: translateX(-50%) scaleX(1);
}

/* 语言选择器样式 */
::v-deep .custom-language-select {
  .el-input__inner {
    background-color: rgba(255, 255, 255, 0.8) !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    border-radius: 8px !important;
    color: #1c2b4e !important;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 30px 8px 12px !important;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
  .el-input__inner:hover {
    background-color: rgba(255, 255, 255, 0.95) !important;
    border-color: rgba(75, 137, 255, 0.3) !important;
    box-shadow: 0 4px 12px rgba(75, 137, 255, 0.15);
  }
  .el-input__inner:focus {
    border-color: #4b89ff !important;
    box-shadow: 0 0 0 3px rgba(75, 137, 255, 0.1);
  }
  .el-select__caret {
    color: #1c2b4e !important;
  }
}
::v-deep .custom-select-popper {
  background-color: rgba(255, 255, 255, 0.98) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 8px 0;
  margin-top: 8px;

  .el-select-dropdown__item {
    color: #1c2b4e;
    padding: 10px 20px;
    font-size: 14px;
    transition: all 0.2s ease;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: rgba(75, 137, 255, 0.1);
    color: #4b89ff;
  }
  .el-select-dropdown__item.selected {
    background-color: rgba(75, 137, 255, 0.15);
    color: #4b89ff;
    font-weight: 600;
  }
  .popper__arrow::after {
    border-bottom-color: rgba(255, 255, 255, 0.98) !important;
  }
}

/* 联系表单样式 */
.form-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}
.form-container {
  width: 800px;
  max-width: 90vw;
  background-color: white;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
}
.form-container::before {
  content: "";
  position: absolute;
  top: -80px;
  right: -80px;
  width: 200px;
  height: 200px;
  background: linear-gradient(to top right, #89f7fe, #66a6ff);
  opacity: 0.3;
  border-radius: 50%;
}
.form-container::after {
  content: "";
  position: absolute;
  bottom: -120px;
  left: -100px;
  width: 300px;
  height: 300px;
  background: linear-gradient(to top right, #89f7fe, #66a6ff);
  opacity: 0.4;
  border-radius: 45%;
  transform: rotate(30deg);
}
.close-btn {
  position: absolute;
  top: 20px;
  right: 25px;
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #888;
  z-index: 10;
  transition: color 0.3s ease;
}
.close-btn:hover {
  color: #333;
}
.form-content {
  display: flex;
  gap: 40px;
  position: relative;
  z-index: 5;
}
.form-fields {
  flex: 2;
}

.form-title {
  margin: 0 0 24px;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  color: #1c2b4e;
  line-height: 1.2;
}

.form-title::after {
  content: "";
  display: block;
  width: 64px;
  height: 4px;
  margin: 18px auto 0;
  background: linear-gradient(90deg, #4b89ff, #296dff);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(75, 137, 255, 0.3);
}
.contact-info {
  flex: 1;
  padding-top: 10px;
}
.form-fields form {
  display: flex;
  flex-direction: column;
}
.form-fields input,
.form-fields textarea {
  width: 90%;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  transition: border-color 0.3s, box-shadow 0.3s;
}
.form-fields input:focus,
.form-fields textarea:focus {
  outline: none;
  border-color: #66a6ff;
  box-shadow: 0 0 0 3px rgba(102, 166, 255, 0.2);
}
.form-fields textarea {
  resize: vertical;
}
.form-fields button[type="submit"] {
  padding: 15px 30px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #4b89ff, #296dff);
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;
}
.form-fields button[type="submit"]:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.contact-info ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.contact-info li {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  font-size: 16px;
  color: #555;
}
.contact-icon {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}

/* 登录表单样式 */
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
  backdrop-filter: blur(5px);
}
.login-modal-container {
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
  width: 400px;
  max-width: 90%;
  position: relative;
  text-align: center;
}
.login-modal-container .close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  color: #aaa;
  cursor: pointer;
  transition: color 0.2s;
}
.login-modal-container .close-btn:hover {
  color: #333;
}
.login-modal-container h2 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
}
.login-modal-container p {
  margin-bottom: 25px;
  color: #666;
  font-size: 16px;
}
.input-group {
  margin-bottom: 20px;
  text-align: left;
}
.input-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #555;
}
.input-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 16px;
}
.btn-login {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #4b89ff, #296dff);
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-login:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.nav-item a.router-link-exact-active {
  color: #409eff;
  font-weight: bold;
}

.nav-item--dropdown {
  position: relative;
}

.nav-dropdown-trigger {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  transition: all 0.25s ease;
  padding: 8px 12px;
  font-family: inherit;
  white-space: nowrap;
  position: relative;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.nav-dropdown-trigger::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 40%;
  height: 3px;
  background: #4b89ff;
  border-radius: 3px 3px 0 0;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-dropdown-trigger:hover,
.nav-dropdown-trigger.active {
  color: #1c2b4e;
  background-color: rgba(75, 137, 255, 0.05);
}

.nav-dropdown-trigger:hover::after,
.nav-dropdown-trigger.active::after {
  transform: translateX(-50%) scaleX(1);
}

.nav-dropdown-caret {
  font-size: 12px;
  line-height: 1;
  transition: transform 0.3s ease;
}

.nav-item--dropdown:hover .nav-dropdown-caret {
  transform: rotate(180deg);
}

.nav-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  min-width: 200px;
  margin: 0;
  padding: 10px;
  list-style: none;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(75, 137, 255, 0.1);
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(28, 43, 78, 0.08);
  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%) translateY(8px);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 100;
}

.nav-item--dropdown::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  min-width: 220px;
  height: 16px;
}

.nav-item--dropdown:hover .nav-dropdown-menu,
.nav-dropdown-menu.open {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.nav-dropdown-menu li {
  margin-bottom: 4px;
}

.nav-dropdown-menu li:last-child {
  margin-bottom: 0;
}

.nav-dropdown-menu a {
  display: block;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.25s ease;
  text-align: left;
}

.nav-dropdown-menu a:hover,
.nav-dropdown-menu a.router-link-active {
  background-color: rgba(75, 137, 255, 0.06);
  color: #4b89ff;
  transform: translateX(4px);
}

.nav-dropdown-menu a::after {
  display: none !important;
}

/* *** 修改后的头部按钮样式 *** */
.btn-header-signup {
  background: linear-gradient(90deg, #4b89ff, #296dff);
  border: none;
  cursor: pointer;
  padding: 10px 24px;
  font-family: inherit;
  color: white;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  text-shadow: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(75, 137, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.btn-header-signup::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.btn-header-signup:hover::before {
  left: 100%;
}

.btn-header-signup:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(75, 137, 255, 0.4);
  background: linear-gradient(90deg, #5b99ff, #3a7dff);
}

.btn-header-signup:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(75, 137, 255, 0.3);
}

/* Hamburger Button Styles */
.hamburger-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 20px;
  cursor: pointer;
  z-index: 20;
}

.hamburger-btn span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #1c2b4e;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Hamburger animation */
.hamburger-btn.active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.hamburger-btn.active span:nth-child(2) {
  opacity: 0;
}

.hamburger-btn.active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

/* Mobile Menu Overlay */
.mobile-menu-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 15;
  backdrop-filter: blur(2px);
}

/* 响应式设计 */
/* 针对14英寸笔记本的优化 - 增加导航项间距 */
@media (min-width: 1366px) and (max-width: 1920px) {
  .nav-list {
    gap: 20px;
    justify-content: space-around;
  }

  .nav-item a,
  .nav-item button {
    font-size: 17px;
    padding: 8px 14px;
  }
}

@media (max-width: 992px) {
  .top-row {
    padding: 0 20px;
    height: 70px;
  }

  .combined-section::before {
    height: 70px;
  }

  .cell {
    height: 70px;
  }

  .cellbt-30 {
    padding-left: 15px;
    gap: 10px;
  }

  .logo-image {
    height: 38px;
  }

  .logo-text {
    font-size: 14px;
    letter-spacing: -0.2px;
  }

  .nav-list {
    gap: 20px;
  }

  .nav-item a,
  .nav-item button {
    font-size: 14px;
    padding: 6px 10px;
  }
}

@media (max-width: 768px) {
  .top-row {
    padding: 0 15px;
    justify-content: space-between;
  }

  .cell-40,
  .cellbt-30 {
    flex: unset;
  }

  /* Show hamburger button */
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 22px;
    width: 26px;
    margin-top: 0;
  }

  /* Show overlay when menu is open */
  .mobile-menu-overlay {
    display: block;
  }

  /* Make logo/text smaller on mobile */
  .logo-image {
    height: 32px;
  }

  .logo-text {
    font-size: 14px;
    letter-spacing: -0.2px;
    line-height: 1.2;
    max-width: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cellbt-30 {
    order: 1; /* Logo on the left */
    gap: 10px;
    padding-left: 0;
    flex: 1; /* Allow logo area to take available space */
    min-width: 0; 
  }

  /* Hamburger button vertical centering fix */
  .cell-40 {
    order: 2; /* Hamburger menu on the right */
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    margin-right: 0;
  }

  /* Responsive Navigation for Mobile */
  .nav-list {
    position: fixed;
    top: 70px; /* Adjust based on header height 70px */
    left: 0;
    width: 100%;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 0.98);
    padding: 20px 0;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-150%);
    transition: transform 0.3s ease-in-out;
    z-index: 16;
    height: auto;
    justify-content: flex-start;
    border-bottom: 1px solid rgba(75, 137, 255, 0.2);
  }

  .nav-list.mobile-open {
    transform: translateY(0);
  }

  .nav-item {
    width: 100%;
    text-align: center;
    margin: 10px 0;
  }

  .nav-item a,
  .nav-item button {
    display: block;
    width: 100%;
    padding: 15px 0;
    font-size: 18px;
  }

  .nav-item--dropdown {
    width: 100%;
  }

  .nav-item--dropdown::after {
    display: none;
  }

  .nav-dropdown-trigger {
    width: 100%;
    justify-content: center;
    font-size: 18px;
    padding: 15px 0;
  }

  .nav-dropdown-menu {
    position: static;
    transform: none;
    opacity: 1;
    visibility: hidden;
    max-height: 0;
    overflow: hidden;
    border: none;
    box-shadow: none;
    background: transparent;
    padding: 0;
    min-width: 0;
    transition: max-height 0.25s ease;
  }

  .nav-dropdown-menu.open {
    visibility: visible;
    max-height: 200px;
    padding-bottom: 8px;
  }

  .nav-dropdown-menu a {
    text-align: center;
    font-size: 16px;
    padding: 10px 0;
  }
}

@media (max-width: 768px) {
  .form-content {
    flex-direction: column;
  }
  .contact-info {
    padding-top: 20px;
    border-top: 1px solid #eee;
    margin-top: 20px;
  }
}
</style>
